import serp from './sections/serp';
import serpVideos from './videos/serp';
import browser from './sections/browser';
import browserVideos from './videos/browser';
import extension from './sections/extension';

export default [
    {
        title: 'Search Engine Result Page (SERP)',
        description: 'Platform owner and technical lead',
        time: 'July 2019 - Present',
        responsible: 'Development and Deployment of a performance-critical, industry-level SERP which includes complex client-side logic for the handling of the homepage and search parameters, a hybrid approach for the rendering of React components including both server-side rendering and client-side rendering to optimize for user experience and resource usage.',
        techstack: 'React.js, Next.js, Material-UI, Node.js, k8s, Docker, Prometheus/Grafana',
        images: serp,
        videos: serpVideos,
    },
    {
        title: 'Desktop Browser',
        description: 'A new safer, faster privacy protecting, ad-blocking browser based on the Mozilla Open Source project',
        time: 'Dec 2016 - Jun 2018',
        responsible: 'Developing, maintaining numerous user-oriented features: Connect – the mobile-desktop sync technology for browser history, tabs and bookmarks; Video Downloader – which enables users to download videos from platforms like YouTube in various media formats (video, audio); Browser theming – implementing design specs at a browser level; Telemetry – implements various privacy preserving measurements for features and activity in the product; History/Bookmark Import - allow users to import browsing activities from other browsers; Alternative Search Engines - offer various famous search engines for users to use and Offer - modern way to show ads on browser, works locally on your device and your privacy is fully protected.',
        techstack: 'Javascript, CSS, Web Worker, Web Socket, Databricks',
        images: browser,
        videos: browserVideos,
    },
    {
        title: 'Extension',
        description: 'Cliqz features, shared across products including Cliqz browsers for Windows, Mac, Android and iOS',
        time: 'September 2016 - Jun 2019',
        responsible: 'Develop and maintain multiple user-facing features where performance is key – such as onboardings, control center, notifications, smart results (Soccer, Lotto, Movie, Cinema, Calculator, Currency, Location, Adult, InfoBox, Wiki, Dialing Code, Top News, News Story, Query Suggestions, Video, Time, Offer, etc.), new tab page , fuzzy history search, and client-side results mixer',
        techstack: 'Javascript, React.js, Ember.js, SCSS, Web Assembly',
        images: extension,
    },
];
